import React from 'react'

const ResumeFrontend = () => {
  return (
    <div>
        <iframe src='/KoushikMB_SWE_Frontend.pdf' className='w-lvw h-lvh' title='Koushik_MB_Frontend_Resume' />
    </div>
  )
}

export default ResumeFrontend